import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import validate from '@/validate/validate';
import Area from '@zzzj/zzzj/src/area';
import { getDetail as _getDetail, fileUpload, tenantDetailSubmit, downLoadTemplate as _downLoadTemplate, uploadTemplate as _uploadTemplate } from '@/api/setting/tenant';
import { imageUrl } from '@/api';
import util from '@/libs/util';
export default {
  name: 'setting-tenant',
  computed: {
    productInfo: function productInfo() {
      if (Array.isArray(this.form.products)) {
        var item = this.form.products.find(function (pro) {
          // 找到作业系统的产品数据
          return pro.type === 1;
        });
        if (item) {
          return item;
        }
      }
      return {};
    },
    downLoadTemplate: function downLoadTemplate() {
      return _downLoadTemplate;
    },
    isAuth: function isAuth() {
      return this.$auth();
    }
  },
  data: function data() {
    return {
      fullscreenLoading: false,
      form: {
        contact: {},
        users: [],
        products: [],
        logo1: undefined,
        logo2: undefined
      },
      rules: {
        'contact.name': [{
          required: true,
          message: '请输入联系人',
          trigger: 'change'
        }],
        'contact.email': [{
          required: true,
          message: '请输入邮箱',
          trigger: 'change'
        }, {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: 'change'
        }],
        'contact.phone': [{
          required: true,
          message: '请输入手机',
          trigger: 'change'
        }, {
          message: '请输入正确的手机号码',
          trigger: 'change',
          validator: validate.isPhone
        }],
        name: [{
          required: true,
          message: '请输入事务所名称',
          trigger: 'change'
        }],
        pca: [{
          required: true,
          message: '请选择注册省市区',
          trigger: 'change'
        }],
        information: [{
          required: true,
          message: '请输入事务所情况及对系统需求',
          trigger: 'change'
        }],
        domain: [{
          required: true,
          message: '请输入租户域名',
          trigger: 'change'
        }],
        address: [{
          required: true,
          message: '请输入注册地址',
          trigger: 'change'
        }],
        postalAddress: [{
          required: true,
          message: '请输入通信地址',
          trigger: 'change'
        }],
        logo1Id: [{
          required: true,
          message: '请上传LOGO',
          trigger: 'change'
        }],
        logo2Id: [{
          required: true,
          message: '请上传LOGO',
          trigger: 'change'
        }]
      },
      options: Area,
      optionsProps: {
        value: 'name',
        label: 'name'
      },
      code: undefined,
      imageSrc1: undefined,
      imageSrc2: undefined,
      loading: false
    };
  },
  methods: {
    uploadTemplate: function uploadTemplate(file) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var formData, _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              formData = new FormData();
              formData.append('file', file);
              _this.fullscreenLoading = true;
              _context.n = 1;
              return _this.$awaitTo(_uploadTemplate(formData));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              _this.fullscreenLoading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _this.$message.success('操作成功');
              _this.getDetail();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    submit: function submit() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var form, _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$checkForm();
            case 1:
              _this2.loading = true;
              form = _objectSpread(_objectSpread({}, _this2.form), {}, {
                phone: _this2.form.contact.phone,
                email: _this2.form.contact.email,
                contact: _this2.form.contact.name
              });
              _context2.n = 2;
              return _this2.$awaitTo(tenantDetailSubmit(form));
            case 2:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 1);
              err = _yield$_this2$$awaitT2[0];
              _this2.loading = false;
              if (!err) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              _this2.$message.success("\u64CD\u4F5C\u6210\u529F");
              _this2.getDetail();
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    createObjectURL: function createObjectURL(file) {
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var url = URL.createObjectURL(new Blob([e.target.result]));
          resolve(url);
        };
        reader.readAsArrayBuffer(file);
      });
    },
    beforeUpload: function beforeUpload(file) {
      if (this.loading) {
        return;
      }
      var isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJPG) {
        this.$message.error('只能是图片格式');
      }
      return isJPG;
    },
    upload: function upload(_ref) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _ref$data, name, Type, logo, file, formData;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _ref$data = _ref.data, name = _ref$data.name, Type = _ref$data.Type, logo = _ref$data.logo, file = _ref.file;
              formData = new FormData();
              formData.append('Forms', file);
              formData.append('Type', Type);
              _context3.n = 1;
              return fileUpload(formData);
            case 1:
              _context3.n = 2;
              return _this3.createObjectURL(file);
            case 2:
              _this3[name] = _context3.v;
              _this3.form[logo] = name;
              _this3.$refs[name].value = '';
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getDetail: function getDetail() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_getDetail, data, contact, form, pca;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _getDetail({
                code: _this4.code
              });
            case 1:
              _yield$_getDetail = _context4.v;
              data = _yield$_getDetail.data;
              contact = {};
              form = data;
              if (form.logo1Id) {
                _this4.imageSrc1 = imageUrl(form.logo1Id);
              }
              if (form.logo2Id) {
                _this4.imageSrc2 = imageUrl(form.logo2Id);
              }
              if (Array.isArray(data.contacts) && data.contacts.length) {
                contact = data.contacts[0];
              }
              if (data.province && data.city && data.area) {
                pca = [data.province, data.city, data.area];
              }
              _this4.form = _objectSpread(_objectSpread({}, form), {}, {
                pca: pca,
                contact: contact
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  },
  created: function created() {
    this.code = util.cookies.get('tenant');
    this.getDetail();
  }
};